import React, {useEffect} from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as modalDataService from './modalDataService';
import { ConnectionTypes } from "./ConnectionTypeSection";

const fieldsetKeys = [
    'apiUrl', 'apiKey', 'apiUsername', 'apiPassword',
    'sshPasswordlessKey', 'sshUsername', 'sshPassword', 
    'winrmPassword', 'winrmUsername', 
    'powerCliUsername', 'powerCliPassword',
    'msTenantId', 'msClientId', 'msSubject'
]

function ConnectionTypeRadio({ connectionType, disabled, selectedDeviceType }) {

    useEffect(() => {
        let typestr = selectedDeviceType?.trim()?.toLowerCase();

        if (typestr) {
            if (typestr.includes('365')) {
                modalDataService.changeConnectionType('M365');
            }
            else if (typestr.includes('microsoft') || typestr.includes('microsoft')) {
                modalDataService.changeConnectionType('WINRM');
            }
            else {
                modalDataService.changeConnectionType('SSH');
            }
        } 

    }, [selectedDeviceType])
    
    const onClick = (value) => {
        if (!disabled) {
            modalDataService.changeConnectionType(value);
            modalDataService.clearFieldset(fieldsetKeys);
        }
    };


    return (
        <>
            <div className="oct_form-title">Connection Type <span className="modal-v2-required-mark">*</span></div>
            <div className="form-inline form-group modal-v2-choice-group">

                {/* API URL */}
                <div className="oct_radio">
                    <label className="oct_radio-label modal-v2-choice-label" onClick={() => onClick(ConnectionTypes.API)}>
                        <input type="radio"
                            name="connection-type"
                            className="modal-v2-choice-input"
                            disabled={disabled}
                            checked={connectionType === ConnectionTypes.API}
                            value={ConnectionTypes.API} readOnly />
                        <span className="font-weight-bold">API URL</span>
                    </label>
                </div>

                {/* SSH */}
                <div className="oct_radio">
                    <label className="oct_radio-label modal-v2-choice-label" onClick={() => onClick(ConnectionTypes.SSH)}>
                        <input type="radio"
                            name="connection-type"
                            className="modal-v2-choice-input"
                            disabled={disabled}
                            checked={connectionType === ConnectionTypes.SSH}
                            value={ConnectionTypes.SSH} readOnly />
                        <span className="font-weight-bold">SSH</span>
                    </label>
                </div>

               {/* WinRM */}
                {/* {
                    selectedDeviceType && selectedDeviceType.toLowerCase().includes("windows") ? */}
                        <div className="oct_radio">
                            <label className="oct_radio-label modal-v2-choice-label" onClick={() => onClick(ConnectionTypes.WINRM)}>
                                <input type="radio"
                                    name="connection-type"
                                    className="modal-v2-choice-input"
                                    disabled={disabled}
                                    checked={connectionType === ConnectionTypes.WINRM}
                                    value={ConnectionTypes.WINRM} readOnly />
                                <span className="font-weight-bold">WinRM</span>
                            </label>
                        </div> 
                        {/* : null */}

                {/* } */}

                {/* PowerCLI */}
                {
                    selectedDeviceType && selectedDeviceType.toLowerCase().includes("vmware") ?
                        <div className="oct_radio">
                            <label className="oct_radio-label modal-v2-choice-label" onClick={() => onClick(ConnectionTypes.PowerCLI)}>
                                <input type="radio"
                                    name="connection-type"
                                    className="modal-v2-choice-input"
                                    disabled={disabled}
                                    //    checked={
                                    //     connectionType === ConnectionTypes.PowerCLI ?
                                    //        true:false
                                    //    }

                                    checked={connectionType === ConnectionTypes.PowerCLI}

                                    value={ConnectionTypes.PowerCLI} readOnly />
                                <span className="font-weight-bold">PowerCLI</span>
                            </label>
                        </div> : null
                }

                {/* M365 */}
                <div className="oct_radio">
                    <label className="oct_radio-label modal-v2-choice-label" onClick={() => onClick(ConnectionTypes.M365)}>
                        <input type="radio"
                            name="connection-type"
                            className="modal-v2-choice-input"
                            disabled={disabled}
                            checked={connectionType === ConnectionTypes.M365}
                            value={ConnectionTypes.M365} readOnly />
                        <span className="font-weight-bold">M365</span>
                    </label>
                </div>

                
                {/* Log File - Not Required anyMore */}
                {/* <div className="oct_radio">
                    <label className="oct_radio-label">
                        <input type="radio"
                               name="connection-type"
                               disabled={disabled}
                               checked={connectionType === ConnectionTypes.LOG_FILE}
                               value={ConnectionTypes.LOG_FILE} readOnly/>
                        <span className="font-weight-bold"
                              onClick={() => onClick(ConnectionTypes.LOG_FILE)}>LOG FILE</span>
                    </label>
                </div> */}

                
            </div>
        </>
    )
}

function mapStateToProps(state) {
    debug("ConnectionTypeRadio mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    return {
        connectionType: addDeviceModal.connectionType
    };
}


export default connect(mapStateToProps)(ConnectionTypeRadio);
